<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="
        chk_relation_type_editable('/article/data') ? fromParentBtn : ''
      "
      :btnClass="'btn-primary'"
      :btnToLink="'/article/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <h5>検索</h5>
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">カテゴリ</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="category_list"
                v-model="sprm.category_id"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div
          class="row mb-1"
          v-if="[3, 4, 5].includes(parseInt(sprm.category_id))"
        >
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">競技種目</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="license_event_cd_list"
                v-model="sprm.license_event_cd"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">ライセンス種別</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="license_class_list"
                v-model="sprm.license_class"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button
              :btnClass="'btn-primary'"
              @to_click_event="search_article"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="w100"
      v-if="
        typeof article_list === 'object' && Object.keys(article_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 15%">商品CD</th>
            <th style="width: auto">名称</th>
            <th style="width: 20%">カテゴリ</th>
            <th style="width: 10%">ソートNo</th>
            <th colspan="3" style="width: 15%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in article_list" :key="list.id">
            <td>{{ list.article_cd }}</td>
            <td>{{ list.label }}</td>
            <td>{{ list.category_label }}</td>
            <td>{{ list.sorts }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                v-if="chk_relation_type_editable('/article/data')"
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="copyClick(list.id)"
                >複製</bs-button
              >
            </td>
            <td>
              <bs-button
                v-if="chk_relation_type_editable('/article/data')"
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-8">
          <bs-page-nav
            :pager_key="'article'"
            @to_click_event="pageAction"
          ></bs-page-nav>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsPageNav from '../../molecules/BsPageNav.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsSelect from '../../atoms/BsSelect.vue'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'ArticleListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '商品マスタ一覧',
      fromParentBtn: 'データ登録',
      article_obj: [],
      category_obj: [],
      license_event_cd_obj: [],
      license_class_obj: [],
      license_category_obj: [],
      sprm: {
        category_id: '',
        license_event_cd: '',
        license_class: '',
        license_category: ''
      },
      page: 0,
      page_limit: 10,
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    BsPageNav,
    BsButton,
    BsMsgAlert,
    BsSelect
  },
  computed: {
    license_event_cd_list: function () {
      const lists = [...this.license_event_cd_obj]
      return lists
        .map(list => {
          list.key = list.id
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_class_list: function () {
      const lists = [...this.license_class_obj]
      return lists
    },
    license_category_list: function () {
      const lists = [...this.license_category_obj]
      return lists
    },
    ...mapState({}),
    get_category_data: function () {
      const category_list = this.category_list
      return function (category_id) {
        return category_list.find(category => category.id == category_id)
      }
    },
    get_category_label: function () {
      const get_func = this.get_category_data
      return function (category_id) {
        if (get_func(category_id)) {
          return get_func(category_id).label
        }
        return ''
      }
    },
    article_list: function () {
      const lists = [...this.article_obj]
      return lists
        .map(list => {
          list.category_label = this.get_category_label(list.category)
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    category_list: function () {
      const lists = [...this.category_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    }
  },

  async created() {
    await this.loadCategoryList()
    await this.loadLicenseClassList()
    await this.loadLicenseCategoryList()
    await this.loadLicenseEventCdList()
    await this.loadSearchParam()
    await this.loadArticleList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '商品マスタです。'
  },

  methods: {
    async delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.article_obj.find(category => {
          return category.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'article' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(async () => {
            await this.loadArticleList()
          })
      }
    },
    async loadArticleList() {
      const params = {}
      params['stat'] = [1]
      if (this.sprm.category_id) params['category_id'] = this.sprm.category_id
      if (this.sprm.license_event_cd)
        params['license_event_cd'] = this.sprm.license_event_cd
      if (this.sprm.license_class)
        params['license_class'] = this.sprm.license_class
      if (this.sprm.license_category)
        params['license_category'] = this.sprm.license_category

      params['pagelimit'] = false
      if (this.page >= 0) params['p'] = this.page
      params['pageorder'] = 'mfj_article_data.sort'
      // params['pageorder'] = this.page_order;
      params['pagesort'] = 'ASC'
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'article'
      })
      await this.basicPosts_S(config.BASE_API_URL + '/article/lists', params)
        .then(async response => {
          console.log('loadArticleList response', response)
          this.article_obj =
            response.data && response.data.body ? response.data.body : []
          this.$store.dispatch('setSearchParam', {
            data: params,
            target: 'article'
          })
          const setPageData = {}
          setPageData.data =
            response.data && response.data.pager ? response.data.pager : {}
          setPageData.target = 'article'
          this.$store.dispatch('setPager', setPageData)
        })
        .catch(async err => {
          console.log(err)
          this.article_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadCategoryList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/article_category/lists',
        params
      )
        .then(async response => {
          console.log('loadCategoryList response', response)
          this.category_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.category_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async search_article() {
      this.isLoading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        this.page = 0
        await this.loadArticleList()
      } finally {
        this.isLoading = false
      }
    },
    clear() {
      const params = { ...this.sprm }
      if (typeof params === 'object') {
        Object.keys(params).forEach(sprm_key => {
          params[sprm_key] = ''
        })
      }
      this.sprm = params
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'article'
      })
    },
    async pageAction(page) {
      this.page = page
      await this.loadArticleList()
    },
    handleClick(target) {
      this.$router.push({ path: '/article/' + target + '/' })
    },
    async copyClick(target) {
      const post_url = config.BASE_API_URL + '/article/copy/' + target

      let result = false
      await this.basicPosts_I(post_url, {})
        .then(async response => {
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.targetid = response.data.body[0].id
            this.alertMessage = '複製しました'
            this.alertClass = 'alert-success'
            result = true
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            // this.targetid = add;
            this.alertMessage = '複製できませんでした 500'
            this.alertClass = 'alert-danger'
          } else {
            console.log('error update status 200 error')
            // this.targetid = 'add';
            this.alertMessage = '複製できませんでした。el'
            this.alertClass = 'alert-danger'
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = '複製できませんでした。CE'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) {
            await this.loadArticleList()
          }
          this.$forceUpdate()
        })

      // this.$router.push({ path: '/article/' + target + '/' })
    },
    async loadSearchParam() {
      const params = { ...this.$store.getters.getSearchParam('article') }
      if (params) {
        Object.keys(params).forEach(key => {
          if (this.is_json(params[key])) {
            params[key] = JSON.parse(params[key])
          }
          this.sprm[key] = params[key]
        })
      }
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseClassList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_class',
        params
      )
        .then(async response => {
          console.log('loadLicenseClassList response', response)
          this.license_class_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_class_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCategoryList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_category',
        params
      )
        .then(async response => {
          console.log('loadLicenseCategoryList response', response)
          this.license_category_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_category_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    }
  }
}
</script>
